import { render, staticRenderFns } from "./OriginCountCell.vue?vue&type=template&id=7681ac5b&scoped=true"
import script from "./OriginCountCell.vue?vue&type=script&lang=js"
export * from "./OriginCountCell.vue?vue&type=script&lang=js"
import style0 from "./OriginCountCell.vue?vue&type=style&index=0&id=7681ac5b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7681ac5b",
  null
  
)

export default component.exports